export const titles = [
    "2nd Lt.",
    "Adm & Mrs.",
    "Adm.",
    "Airman",
    "Ambdr.",
    "Archbishop",
    "Baroness",
    "Bishop",
    "Br.",
    "Brig.",
    "Brig. & Mrs.",
    "Brig. Gen.",
    "Brother",
    "C.W.O.",
    "CPO",
    "Capt.",
    "Capt. & Mrs.",
    "Cardinal",
    "Chaplain",
    "Cmdr.",
    "Cmdr. & Mrs.",
    "Col.",
    "Col. & Mrs.",
    "Col. & Ms.",
    "Comr.",
    "Cpl.",
    "Deacon",
    "Dean",
    "Dr.",
    "Dr. & Dr.",
    "Dr. & Mrs.",
    "Dr. & Ms.",
    "Elder",
    "Ensign",
    "Fr.",
    "Gen.",
    "Gen. & Mrs.",
    "Gov.",
    "Gov. & Mrs.",
    "Hon.",
    "Hon. & Mrs.",
    "Judge",
    "Judge & Mrs.",
    "Lt Col & Mrs",
    "Lt.",
    "Lt. & Mrs.",
    "Lt. Cmdr.",
    "Lt. Col.",
    "Lt. Cpl.",
    "Lt. Gen.",
    "Lt. Jg.",
    "Maj. & Mrs.",
    "Maj. Gen.",
    "Major",
    "Miss",
    "Misses",
    "Most Rev.",
    "Mother",
    "Mr.",
    "Mr. & Mrs.",
    "Mr. & Ms.",
    "Mrs.",
    "Ms.",
    "Msgr.",
    "Ofcr.",
    "PO",
    "Pastor",
    "Pres.",
    "Prof.",
    "Pvt.",
    "Rabbi",
    "Rabbi & Mrs.",
    "Rep.",
    "Rev.",
    "Rev. & Mrs.",
    "Rev. Msgr.",
    "Rt. Rev.",
    "SFC",
    "SSg.",
    "SXgt.",
    "Seaman",
    "Sen.",
    "Sen. & Mrs.",
    "Sgm. & Mrs.",
    "Sgt.",
    "Sgt. & Mrs.",
    "Sgt. Maj.",
    "Sheik",
    "Spec.",
    "Sr.",
    "Ssgt.",
    "The Hon.",
    "The Most Rev",
    "The Rev.",
];

export const surnameSuffixes = [
    "CPA",
    "DDS",
    "DO",
    "DVM",
    "Esq",
    "Family",
    "I",
    "II",
    "III",
    "IV",
    "Jr.",
    "MD",
    "PHD",
    "RN",
    "Ret",
    "Rev",
    "Sr.",
];

export const states: Array<{ name: string; abbreviation: string }> = [
    { name: "Alabama", abbreviation: "AL" },
    { name: "Alaska", abbreviation: "AK" },
    { name: "Arizona", abbreviation: "AZ" },
    { name: "Arkansas", abbreviation: "AR" },
    { name: "California", abbreviation: "CA" },
    { name: "Colorado", abbreviation: "CO" },
    { name: "Connecticut", abbreviation: "CT" },
    { name: "Delaware", abbreviation: "DE" },
    { name: "Florida", abbreviation: "FL" },
    { name: "Georgia", abbreviation: "GA" },
    { name: "Hawaii", abbreviation: "HI" },
    { name: "Idaho", abbreviation: "ID" },
    { name: "Illinois", abbreviation: "IL" },
    { name: "Indiana", abbreviation: "IN" },
    { name: "Iowa", abbreviation: "IA" },
    { name: "Kansas", abbreviation: "KS" },
    { name: "Kentucky", abbreviation: "KY" },
    { name: "Louisiana", abbreviation: "LA" },
    { name: "Maine", abbreviation: "ME" },
    { name: "Maryland", abbreviation: "MD" },
    { name: "Massachusetts", abbreviation: "MA" },
    { name: "Michigan", abbreviation: "MI" },
    { name: "Minnesota", abbreviation: "MN" },
    { name: "Mississippi", abbreviation: "MS" },
    { name: "Missouri", abbreviation: "MO" },
    { name: "Montana", abbreviation: "MT" },
    { name: "Nebraska", abbreviation: "NE" },
    { name: "Nevada", abbreviation: "NV" },
    { name: "New Hampshire", abbreviation: "NH" },
    { name: "New Jersey", abbreviation: "NJ" },
    { name: "New Mexico", abbreviation: "NM" },
    { name: "New York", abbreviation: "NY" },
    { name: "North Carolina", abbreviation: "NC" },
    { name: "North Dakota", abbreviation: "ND" },
    { name: "Ohio", abbreviation: "OH" },
    { name: "Oklahoma", abbreviation: "OK" },
    { name: "Oregon", abbreviation: "OR" },
    { name: "Pennsylvania", abbreviation: "PA" },
    { name: "Rhode Island", abbreviation: "RI" },
    { name: "South Carolina", abbreviation: "SC" },
    { name: "South Dakota", abbreviation: "SD" },
    { name: "Tennessee", abbreviation: "TN" },
    { name: "Texas", abbreviation: "TX" },
    { name: "Utah", abbreviation: "UT" },
    { name: "Vermont", abbreviation: "VT" },
    { name: "Virginia", abbreviation: "VA" },
    { name: "Washington", abbreviation: "WA" },
    { name: "West Virginia", abbreviation: "WV" },
    { name: "Wisconsin", abbreviation: "WI" },
    { name: "Wyoming", abbreviation: "WY" },
];
